import { DTH_OPERATORS, CABLE_OPERATORS } from "@/data/content";
import { Reveal, Kicker } from "@/components/Reveal";
import Marquee from "@/components/Marquee";

export default function WhereToWatch({ dark = false }) {
    const cableItems = CABLE_OPERATORS.map(([name, lcn]) => (
        <span key={name} className="inline-flex items-baseline gap-2">
            <span className={`font-display text-sm font-bold uppercase tracking-wider ${dark ? "text-white/80" : "text-[#0F0F23]/80"}`}>{name}</span>
            <span className="font-mono2 text-sm font-bold text-[#C8102E]">{lcn}</span>
            <span className="mx-5 text-[#FFA200]">✦</span>
        </span>
    ));

    return (
        <section data-testid="where-to-watch" className={`py-20 sm:py-28 ${dark ? "bg-[#0F0F23]" : "bg-[#F5F5F5]"}`}>
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <Kicker light={!dark}>Where To Watch</Kicker>
                    <h2 className={`font-display mt-4 max-w-2xl text-3xl font-black tracking-tight sm:text-4xl ${dark ? "text-white" : "text-[#0F0F23]"}`}>
                        Available on leading platforms
                    </h2>
                    <p className={`mt-3 max-w-xl text-sm sm:text-base ${dark ? "text-[#9999BB]" : "text-[#555566]"}`}>
                        Reaching 2.5 crore households across West Bengal, Tripura, Assam and Eastern India through 25+ cable &amp; DTH operators.
                    </p>
                </Reveal>
                <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
                    {DTH_OPERATORS.map((op, i) => (
                        <Reveal key={op.name} delay={i * 0.08}>
                            <div
                                data-testid={`dth-card-${op.name.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`group rounded-2xl border p-6 transition-colors duration-300 ${
                                    dark
                                        ? "border-white/10 bg-[#16162B] hover:border-[#C8102E]/60"
                                        : "border-black/10 bg-white hover:border-[#C8102E]/50"
                                }`}
                            >
                                <p className={`text-[10px] font-bold uppercase tracking-[0.2em] ${dark ? "text-[#9999BB]" : "text-[#555566]"}`}>
                                    {op.name}
                                </p>
                                <p className="font-mono2 mt-3 text-4xl font-black tracking-tight text-[#C8102E] transition-colors group-hover:text-[#FFA200] sm:text-5xl">
                                    {op.lcn}
                                </p>
                                <p className={`mt-2 text-[10px] font-semibold uppercase tracking-[0.2em] ${dark ? "text-white/40" : "text-[#0F0F23]/40"}`}>
                                    Channel Number
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
            <Reveal delay={0.1} className="mt-12">
                <Marquee slow items={cableItems} itemClassName="px-2" />
            </Reveal>
        </section>
    );
}
